import axios from 'axios'

const makeFetchRequest = (names) => ({
    action: 'fetch',
    payload: {
        names
    }
})

const fetchGigs = async (names) => {
    const serviceUrl = process.env.REACT_APP_AGENT_URL
    
    const gigs = await axios.post(serviceUrl, makeFetchRequest(names))

    return gigs
}

export default fetchGigs
